module.exports = __webpack_public_path__ + "img/news6.08a59726.png";